import type { Report } from 'corso-admin-ui';
import { productReasonTables, reasonTables } from '../claimItems';
import { returnReasonCharts } from '../reasonCharts';

export const reasons = {
  key: 'reasons',
  label: 'Reasons',
  dataset: 'claimItems',
  timeFields: ['createdOn', 'finalizedOn'],
  widgets: [...returnReasonCharts, ...reasonTables, ...productReasonTables],
} as const satisfies Report;
